var _objectSpread = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread");

var isArray = function isArray(arr) {
  return Array.isArray(arr);
};

var isString = function isString(str) {
  return typeof str === 'string' || str instanceof String;
};

var isInt = function isInt(val) {
  return Number.isInteger(val);
};

var isFunction = function isFunction(func) {
  return func !== null && typeof func === 'function';
};

var URL_REGEX = /^\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/; // eslint-disable-line

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};

var AND = function AND(v1, v2) {
  return v1 && v2;
};

var OR = function OR(v1, v2) {
  return v1 || v2;
};

var looseEqual = function looseEqual(a, b) {
  if (a === b) return true;
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  var isArrayA = isArray(a);
  var isArrayB = isArray(b);
  var ret = false;

  if (isArrayA && isArrayB) {
    ret = a.length === b.length && a.every(function (e, i) {
      return looseEqual(e, b[i]);
    });
  }

  if (a instanceof Date && b instanceof Date) {
    ret = a.getTime() === b.getTime();
  }

  if (isObjectA && isObjectB) {
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    ret = keysA.length === keysB.length && keysA.every(function (key) {
      return looseEqual(a[key], b[key]);
    });
  }

  return ret;
};

function mapFirstArgument(f, map) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var arg = args;
    arg[0] = map(arg[0]);
    return f.apply(void 0, arg);
  };
}

function mergeRule(rule1, rule2, mapFunction) {
  var keys = Object.keys(rule2);
  var mappedCopy = {};
  keys.forEach(function (key) {
    mappedCopy[key] = mapFirstArgument(rule2[key], mapFunction);
  });
  return _objectSpread({}, rule1, mappedCopy, {
    type: function type(val) {
      return rule1.type(val) && rule2.type(mapFunction(val));
    }
  });
}

module.exports = {
  isArray: isArray,
  isString: isString,
  isFunction: isFunction,
  isObject: isObject,
  URL_REGEX: URL_REGEX,
  looseEqual: looseEqual,
  AND: AND,
  OR: OR,
  isInt: isInt,
  mapFirstArgument: mapFirstArgument,
  mergeRule: mergeRule
};